<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title">{{ $t("user.create") }}</h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout" style="text-align: center">
                <!-- Avatar -->
                <!--                <div class="md-layout-item md-size-100">-->
                <!--                  <h4 class="card-title">{{ $t("user.avatar") }}</h4>-->
                <!--                  <div class="file-input img-circle">-->
                <!--                    <template v-if="!imageCircle">-->
                <!--                      <div class="image-fix-container">-->
                <!--                        <img :src="avatarImg" title="" />-->
                <!--                      </div>-->
                <!--                    </template>-->
                <!--                    <div class="image-fix-container" v-else>-->
                <!--                      <img :src="imageCircle" />-->
                <!--                    </div>-->
                <!--                    <div class="button-container">-->
                <!--                      <md-button-->
                <!--                        class="md-success md-round md-fileinput"-->
                <!--                        @click="onFileChange"-->
                <!--                      >-->
                <!--                        <template v-if="!imageCircle">{{-->
                <!--                          $t("user.add_avatar")-->
                <!--                        }}</template>-->
                <!--                        <template v-else>{{-->
                <!--                          $t("user.change_avatar")-->
                <!--                        }}</template>-->
                <!--                      </md-button>-->
                <!--                    </div>-->
                <!--                  </div>-->
                <!--                </div>-->
                <div class="md-layout-item md-size-100">
                  <div class="md-layout">
                    <!-- Username -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <label
                          class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label  required-field"
                        >
                          {{ $t("user.username") }}
                        </label>
                        <div class="md-layout-item md-xsmall-size-100">
                          <ValidationProvider
                            :name="$t('user.username')"
                            rules="required|min:6|max:20|notIncludeSpecialChar"
                            v-slot="{ passed, failed, errors }"
                          >
                            <md-field
                              :class="[
                                { 'md-error': failed },
                                { 'md-valid': passed }
                              ]"
                            >
                              <md-input
                                v-model="params.username"
                                type="text"
                                ref="username"
                              ></md-input>

                              <slide-y-down-transition>
                                <md-icon class="error" v-show="failed"
                                  >close</md-icon
                                >
                              </slide-y-down-transition>
                              <slide-y-down-transition>
                                <md-icon class="success" v-show="passed"
                                  >done</md-icon
                                >
                              </slide-y-down-transition>
                            </md-field>
                            <div class="validate-error">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <!-- Password -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <div class="md-layout-item md-size-80">
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-25 md-form-label required-field"
                            >
                              {{ $t("auth.password") }}
                            </label>
                            <div class="md-layout-item md-xsmall-size-100">
                              <ValidationProvider
                                :name="$t('auth.password')"
                                rules="required|min:8|max:20"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.password"
                                    type="password"
                                    disabled=""
                                  ></md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close</md-icon
                                    >
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done</md-icon
                                    >
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                        <div class="md-layout-item md-size-20">
                          <md-button
                            native-type="button"
                            class="md-primary"
                            @click="resetPassword()"
                          >
                            Cấp mới
                          </md-button>
                        </div>
                      </div>
                    </div>
                    <!-- Role -->
                    <!--                    <div class="md-layout-item md-size-100">-->
                    <!--                      <div class="md-layout">-->
                    <!--                        <label-->
                    <!--                          class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label  required-field"-->
                    <!--                        >-->
                    <!--                          {{ $t("user.role") }}-->
                    <!--                        </label>-->
                    <!--                        <div class="md-layout-item md-xsmall-size-100">-->
                    <!--                          <ValidationProvider-->
                    <!--                            :name="$t('user.role')"-->
                    <!--                            rules="required"-->
                    <!--                            v-slot="{ passed, failed, errors }"-->
                    <!--                          >-->
                    <!--                            <md-field-->
                    <!--                              :class="[-->
                    <!--                                { 'md-error': failed },-->
                    <!--                                { 'md-valid': passed }-->
                    <!--                              ]"-->
                    <!--                            >-->
                    <!--                              <md-select v-model="params.roleId">-->
                    <!--                                <md-option-->
                    <!--                                  v-for="option in roles"-->
                    <!--                                  :key="option.id"-->
                    <!--                                  :value="option.id"-->
                    <!--                                  >{{ option.name }}-->
                    <!--                                </md-option>-->
                    <!--                              </md-select>-->

                    <!--                              <slide-y-down-transition>-->
                    <!--                                <md-icon class="error" v-show="failed"-->
                    <!--                                  >close</md-icon-->
                    <!--                                >-->
                    <!--                              </slide-y-down-transition>-->
                    <!--                              <slide-y-down-transition>-->
                    <!--                                <md-icon class="success" v-show="passed"-->
                    <!--                                  >done</md-icon-->
                    <!--                                >-->
                    <!--                              </slide-y-down-transition>-->
                    <!--                            </md-field>-->
                    <!--                            <div class="validate-error">{{ errors[0] }}</div>-->
                    <!--                          </ValidationProvider>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                    <!-- Email -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <label
                          class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label  required-field"
                        >
                          {{ $t("user.email") }}
                        </label>
                        <div class="md-layout-item md-xsmall-size-100">
                          <ValidationProvider
                            :name="$t('user.email')"
                            rules="email|max:50|required"
                            v-slot="{ passed, failed, errors }"
                          >
                            <md-field
                              :class="[
                                { 'md-error': failed },
                                { 'md-valid': passed }
                              ]"
                            >
                              <md-input
                                v-model.trim="params.email"
                                type="text"
                              ></md-input>
                              <slide-y-down-transition>
                                <md-icon class="error" v-show="failed"
                                  >close</md-icon
                                >
                              </slide-y-down-transition>
                              <slide-y-down-transition>
                                <md-icon class="success" v-show="passed"
                                  >done</md-icon
                                >
                              </slide-y-down-transition>
                            </md-field>
                            <div class="validate-error">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <!-- First Name -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <label
                          class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label "
                        >
                          {{ $t("user.first_name") }}
                        </label>
                        <div class="md-layout-item md-xsmall-size-100">
                          <ValidationProvider
                            :name="$t('user.first_name')"
                            rules="max:50"
                            v-slot="{ passed, failed, errors }"
                          >
                            <md-field
                              :class="[
                                { 'md-error': failed },
                                { 'md-valid': passed }
                              ]"
                            >
                              <md-input
                                v-model="params.first_name"
                                type="text"
                              ></md-input>

                              <slide-y-down-transition>
                                <md-icon class="error" v-show="failed"
                                  >close
                                </md-icon>
                              </slide-y-down-transition>
                              <slide-y-down-transition>
                                <md-icon class="success" v-show="passed"
                                  >done
                                </md-icon>
                              </slide-y-down-transition>
                            </md-field>
                            <div class="validate-error">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <!-- Last Name -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <label
                          class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label "
                        >
                          {{ $t("user.last_name") }}
                        </label>
                        <div class="md-layout-item md-xsmall-size-100">
                          <ValidationProvider
                            :name="$t('user.last_name')"
                            rules="max:50"
                            v-slot="{ passed, failed, errors }"
                          >
                            <md-field
                              :class="[
                                { 'md-error': failed },
                                { 'md-valid': passed }
                              ]"
                            >
                              <md-input
                                v-model="params.last_name"
                                type="text"
                              ></md-input>

                              <slide-y-down-transition>
                                <md-icon class="error" v-show="failed"
                                  >close
                                </md-icon>
                              </slide-y-down-transition>
                              <slide-y-down-transition>
                                <md-icon class="success" v-show="passed"
                                  >done
                                </md-icon>
                              </slide-y-down-transition>
                            </md-field>
                            <div class="validate-error">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </md-card-content>

            <md-card-actions class="text-center">
              <md-button type="submit" class="md-success"
                >{{ $t("common.save") }}
              </md-button>
              <router-link :to="{ name: 'UsersList' }">
                <md-button native-type="button"
                  >{{ $t("common.cancel") }}
                </md-button>
              </router-link>
            </md-card-actions>
          </md-card>
        </form>
      </ValidationObserver>
    </div>
    <crop-upload-image-modal
      :modal-data="modalAvatar"
      :origin-img-src="imageCircle"
      :min-container-width="340"
      :min-container-height="260"
      :background="true"
      :rotatable="false"
      :img-style="{ width: '320px', height: '220px' }"
      :aspect-ratio="1"
      :click-outside-to-close="false"
      @closeModal="closeModalChangeAvatar"
      @setCroppedImageSrc="updateAvatar"
    ></crop-upload-image-modal>
  </div>
</template>
<script>
import CropUploadImageModal from "../../components/VueUploadMultipleImage/CropUploadImageModal";
import queryHelper from "@/helpers/query-helper";
import sanitizer from "sanitizer";
import { UserService } from "../../services/user.service";

export default {
  name: "UserCreateForm",
  components: {
    CropUploadImageModal
  },
  props: {
    avatarImg: {
      type: String,
      default: "../img/image_placeholder.jpg"
    }
  },
  data() {
    return {
      modalAvatar: {
        show: false,
        action: "create"
      },
      users: [],
      roles: [],
      characters: "a-z,A-Z,0-9",
      imageCircle: "",
      params: {
        username: null,
        email: null,
        first_name: null,
        last_name: null,
        password: null
      }
    };
  },
  methods: {
    submit() {
      this.createUser();
    },
    async createUser() {
      let formData = this.buildFormDataCreateUser();
      const response = await new UserService().create(formData);
      if (!response) return;
      this.$notify({
        title: this.$t("user.created"),
        text: this.$t("user.created_text", {
          name: ""
        }),
        type: "success"
      });
      setTimeout(() => this.$router.push({ name: "UsersList" }), 500);
    },
    buildFormDataCreateUser() {
      let params = this.params;

      if (!params.password) delete params.password;
      if (!params.email) delete params.email;
      if (!params.first_name) delete params.first_name;
      if (!params.last_name) delete params.last_name;

      return params;
    },
    async getRoles() {
      this.roles = await UserService.getRoles({
        order_by: "id asc",
        limit: 100
      });
    },
    resetPassword() {
      let charactersArray = this.characters.split(",");
      let CharacterSet = "";
      let password = "";

      if (charactersArray.indexOf("a-z") >= 0) {
        CharacterSet += "abcdefghijklmnopqrstuvwxyz";
      }
      if (charactersArray.indexOf("A-Z") >= 0) {
        CharacterSet += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      }
      if (charactersArray.indexOf("0-9") >= 0) {
        CharacterSet += "01234567890123456789";
      }
      for (let i = 0; i < 15; i++) {
        password += CharacterSet.charAt(
          Math.floor(Math.random() * CharacterSet.length)
        );
      }
      this.params.password = password;
    },
    onFileChange(e) {
      this.showModalChangeAvatar("edit");
    },
    updateAvatar(file) {
      this.params.picture = file;
      this.createImage(file, "circle");
    },
    createImage(file, type) {
      let reader = new FileReader();
      let vm = this;

      reader.onload = e => {
        if (type === "circle") {
          vm.imageCircle = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    },
    closeModalChangeAvatar() {
      this.modalAvatar.show = false;
      this.$store.commit("DESTROY_MODAL");
    },
    showModalChangeAvatar(action) {
      this.modalAvatar.action = action || "create";
      this.modalAvatar.show = true;
      this.$store.commit("SHOW_MODAL");
    }
  },
  mounted() {
    // this.getRoles();
  }
};
</script>

<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.text-center {
  justify-content: center !important;
}

.md-field .success.md-icon,
.md-field .error.md-icon {
  right: -20px;
}

.image-fix-container {
  max-width: 250px;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 10px;
  box-shadow: 0 10px 30px -12px rgb(0 0 0 / 42%), 0 4px 25px 0 rgb(0 0 0 / 12%),
    0 8px 10px -5px rgb(0 0 0 / 20%);
}
</style>
